import * as actions from '@app/actions/index';
import { AccountStatusEnum } from '@app/app.enum';
import * as constants from '@app/constants/index';
import * as models from '@app/models/index';

export function authReducer(
	state: models.IAppReduxAuthenticationState = {},
	action: actions.AuthActions
): models.IAppReduxAuthenticationState {
	switch (action.type) {
		case constants.USER_SIGNED_IN:
			return {
				apiKey: action.payload.apiKey,
				user: action.payload.user,
				isAuthenticated: true,
				status: action.payload.status,
			};
		case constants.USER_SIGNED_OUT:
			return {
				isAuthenticated: false,
			};
		case constants.USER_SIGNED_UP:
			return {
				apiKey: action.payload.apiKey,
				user: action.payload.user,
				isAuthenticated: true,
				status: AccountStatusEnum.Active,
			};
		case constants.USER_CLOSE_ACCOUNT:
			return {
				...state,
				status: AccountStatusEnum.Closed,
			};
		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/account.reducers.ts